import { useEffect, useState } from 'react';
import {
  QualioAttachmentInfoResponse,
  QualioAttachmentPreviewType,
} from '../../../../api/document';
import { qualioAttachmentService } from '../../../../api/qualioAttachmentService';
import { getAttachmentPreviewUrl } from '../../../../util/UrlUtils';

const attachmentConversionSuccessful = (
  attachmentConversionStatus: QualioAttachmentInfoResponse,
): boolean =>
  attachmentConversionStatus &&
  qualioAttachmentService.attachmentPreviewSuccessful(
    attachmentConversionStatus,
  );

export type QualioAttachmentPreview = {
  id: string;
  url: string;
  filename: string;
  mimeType: string;
  previewType: QualioAttachmentPreviewType;
};

export const useAttachmentPreview = (attachmentId: string) => {
  const [previewError, setPreviewError] = useState<boolean>();

  const [attachmentPreview, setAttachmentPreview] =
    useState<QualioAttachmentPreview | null>(null);

  useEffect(() => {
    const awaitConversionResults = async () => {
      if (attachmentId) {
        setPreviewError(false);
        const conversionResult =
          await qualioAttachmentService.pollAttachmentInfoUntilCompletion(
            attachmentId,
          );
        if (
          conversionResult &&
          attachmentConversionSuccessful(conversionResult)
        ) {
          setAttachmentPreview({
            id: attachmentId,
            filename: conversionResult.filename,
            mimeType: qualioAttachmentService.determinePreviewContentMimeType(
              conversionResult.filename,
            ),
            url: getAttachmentPreviewUrl(attachmentId),
            previewType: conversionResult?.preview_type ?? 'unsupported',
          });
        } else {
          setPreviewError(true);
        }
      }
    };

    void awaitConversionResults();
  }, [attachmentId]);

  return {
    attachmentPreview,
    previewError,
  };
};
